var map = {
	"./": 763,
	"./double": 167,
	"./double sided pendant.svg": 735,
	"./double/": 167,
	"./double/index": 167,
	"./double/index.ts": 167,
	"./double/one pendant.svg": 597,
	"./double/three pendants.svg": 284,
	"./double/two pendants.svg": 26,
	"./index": 763,
	"./index.ts": 763,
	"./one sided pendant.svg": 334,
	"./single": 60,
	"./single/": 60,
	"./single/index": 60,
	"./single/index.ts": 60,
	"./single/one pendant.svg": 818,
	"./single/three pendants.svg": 217,
	"./single/two pendants.svg": 511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 729;